import { IString } from '../../../model';
import { ITableColumn, TableFilter } from '../model';

export function getFilterData<T>(
  data: ReadonlyArray<T>,
  values: IString<string | string[]>,
  columns: ReadonlyArray<ITableColumn<T>>
) {
  const oColumnFilter: IString<TableFilter<T>> = {};
  columns.forEach((item) => {
    if (item.filters) {
      oColumnFilter[item.key] = item.filters;
    }
  });
  const newData = data.filter((record: T) => {
    /* eslint-disable */
    for (const i in oColumnFilter) {
      const filter = oColumnFilter[i];
      if (!filter) {
        continue;
      }
      if (!filter.onFilter) {
        continue;
      }
      const value = values[i];
      if (!value) {
        continue;
      }
      const res = filter.onFilter(value, record);
      if (!res) {
        return false;
      }
    }
    return true;
  });
  return newData;
}

export const isFilterSelected = (value: string | string[]) => {
  if (typeof value === 'string') {
    return !!value;
  }
  if (Array.isArray(value)) {
    return !!value.length;
  }
  return false;
};
